import { useEffect, useState, useMemo } from "react";
import { FiChevronDown } from "react-icons/fi";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { useNavigate } from "react-router";
import { DEFINED_PERMISSIONS } from "../../../../../utils/const";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import { useSearchFilter } from "../../../../../utils/functions/useDate";
import {
  useGetAppraisalObjectiveMainQuery,
  useGetHrDepartmentsQuery,
  useGetJobRoleQuery,
} from "../../../../api/hrApi";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import { ActionButtons } from "../../../../global/components/Buttons/buttons";
import PageStyle from "../../../Components/Layout/PageLayout";
import { TableActions } from "../../../Components/Misc/Actions";
import Actions from "../../../Components/Misc/Actions/Actions.module.css";
import { AppModalTemplate } from "../../../Components/Modals/Modals";
import {
  CalendarFilter2,
  ProDropFilter,
  SearchFilter,
} from "../../../Components/Search/Search";
import Table from "../../../Components/Table/Table";
import { AutogeneratedKRAModal } from "./Modals/AutogeneratedKRAModal";
import { ObjectiveModal3 } from "./Modals/ObjectiveModal3";
import { FilterByStatus } from "./status";
import Pagination from "../../../Components/Pagination/Pagination";

const KeyResultArea = () => {
  const {
    searchText,
    filter,
    setSearchText,
    setFilter,
    pageSize,
    currentPage,
    setPageSize,
    setCurrentPage,
  } = useSearchFilter({
    initialFilter: 1,
  });

  const [openAutogeneratedModal, setOpenAutogeneratedModal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [matchedPermissionHr, setMatchedPermissionHr] = useState("");
  const [matchedPermissionJAO, setMatchedPermissionJAO] = useState("");
  const [soaPerm, setSoaPerm] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [open, setOpen] = useState(false);
  const [yearFilter, setYearFilter] = useState("All Years");
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const hrPerm = [
      DEFINED_PERMISSIONS.SeniorHRManager,
      DEFINED_PERMISSIONS.PrimaryHRManager,
      DEFINED_PERMISSIONS.SeniorAppraisalOfficer,
    ];
    const definedSoaPerm = DEFINED_PERMISSIONS.SeniorAppraisalOfficer;
    const hasSoaPermission = userPerm.includes(definedSoaPerm);
    setSoaPerm(hasSoaPermission);
    if (userPerm && userPerm.some((perm) => hrPerm.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => hrPerm.includes(perm));
      setMatchedPermissionHr(matchedPerm);
    } else {
      setMatchedPermissionHr("");
    }
  }, []);
  useEffect(() => {
    const userPerm = JSON.parse(localStorage.getItem("x-u-perm"));
    const JOA = [DEFINED_PERMISSIONS.JuniorAppraisalOfficer];
    if (userPerm && userPerm.some((perm) => JOA.includes(perm))) {
      const matchedPerm = userPerm.find((perm) => JOA.includes(perm));
      setMatchedPermissionJAO(matchedPerm);
    } else {
      setMatchedPermissionJAO("");
    }
  }, []);
  const navigate = useNavigate();

  const handleModal = () => {
    setOpenModal(!openModal);
  };
  const handleAutogeneratedModal = () => {
    setOpenAutogeneratedModal(!openAutogeneratedModal);
  };
  const onValidate = () => {
    setOpenModal(false);
  };

  const [departmentId, setDepartmentId] = useState("");
  const [jobRoleId, setJobRoleId] = useState("");
  const { data, isLoading } = useGetAppraisalObjectiveMainQuery({
    PageNumber: currentPage,
    PageSize: pageSize,
    DepartmentId: departmentId,
    JobRoleId: jobRoleId,
    GeneralSearch: searchText,
    ApprovalStatus: "0",
    StartDate: startDate,
    EndDate: endDate,
    year: yearFilter === "All Years" ? "" : yearFilter || "",
  });
  const currentYear = new Date().getFullYear();
  const dates = [
    { name: "All Years", filter: "" },
    ...Array.from({ length: currentYear - 1999 + 1 }, (_, i) => ({
      name: (currentYear - i).toString(),
      filter: (currentYear - i).toString(),
    })),
  ];
  const actionButton = (
    <div>
      {(!soaPerm || (matchedPermissionHr && matchedPermissionJAO)) && (
        <ActionButtons
          width={"auto"}
          className={DashboardStyle?.button_cage_weight}
          style={{
            backgroundColor: "var(--primary-color)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
          onClick={() => setOpen(!open)}
          type="button"
        >
          <FiChevronDown /> Create
        </ActionButtons>
      )}
      {open && (
        <div
          className={`
           absolute z-10 bg-white w-[220px] right-5 shadow-lg rounded-md mt-2`}
        >
          <button
            onClick={handleModal}
            className={`${Actions.more_action_button} w-full`}
          >
            + Add KRA
          </button>
          {matchedPermissionJAO && (
            <button
              onClick={handleAutogeneratedModal}
              className={`${Actions.more_action_button} w-full`}
            >
              + Add Autogenerated KRA
            </button>
          )}
        </div>
      )}
    </div>
  );

  const handleView = (id) => {
    if (id) {
      navigate(`${id}/view`);
    }
  };

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  const sortedData = useMemo(() => {
    if (!data?.result) return [];
    return [...data.result].sort((a, b) => {
      if (!sortColumn) return 0;
      let aValue = a[sortColumn];
      let bValue = b[sortColumn];

      if (sortColumn === "createdDate") {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      } else if (sortColumn === "weight") {
        aValue = parseFloat(aValue);
        bValue = parseFloat(bValue);
      } else if (sortColumn === "year") {
        aValue = parseInt(aValue);
        bValue = parseInt(bValue);
      }

      if (aValue < bValue) return sortDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return sortDirection === "asc" ? 1 : -1;
      return 0;
    });
  }, [data?.result, sortColumn, sortDirection]);

  const renderSortIcon = (column) => {
    if (sortColumn !== column) return <FaSort className="ml-1" />;
    return sortDirection === "asc" ? (
      <FaSortUp className="ml-1" />
    ) : (
      <FaSortDown className="ml-1" />
    );
  };

  const { data: JobRole } = useGetJobRoleQuery({
    ApprovalStatus: 0,
    PageSize: 9999,
    PageNumber: 1,
  });
  const { data: departments } = useGetHrDepartmentsQuery();
  return (
    <PageStyle
      action={actionButton}
      hasBack={true}
      hasTopPageDemo
      backURL={"/dashboard/hr/HR-Appraisal-Setup"}
      support={
        "Setup KRA's that aligns with job objectives to enable measurable goal-oriented appraisals."
      }
      demoTitle={"Objectives & KRA Review"}
    >
      <form className={DashboardStyle.dashboard_filter}>
        <SearchFilter
          value={searchText}
          text={(searchText) => setSearchText(searchText)}
        />
        {/* <ProDropFilter
          filter={filter}
          setFilter={setFilter}
          name={"Status"}
          filterBy={FilterByStatus}
        /> */}
        <ProDropFilter
          filter={yearFilter}
          setFilter={setYearFilter}
          name={"Year"}
          filterBy={dates}
        />
        <CalendarFilter2
          name="Select Date Range"
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          normalDate
        />
        <ProDropFilter
          filter={departmentId}
          setFilter={setDepartmentId}
          name={"Deparment"}
          filterBy={departments?.responseObject?.pageItems?.map(
            (depatment) => ({
              name: depatment.name,
              filter: depatment.id,
            })
          )}
        />
        <ProDropFilter
          filter={jobRoleId}
          setFilter={setJobRoleId}
          name={"Job Role"}
          filterBy={JobRole?.responseObject?.pageItems?.map((job) => ({
            name: job.designationName,
            filter: job.id,
          }))}
        />
      </form>
      <div className={DashboardStyle.dashboard_table_holder}>
        <Table>
          <thead>
            <tr>
              <th>S/N</th>
              <th
                onClick={() => handleSort("title")}
                style={{ cursor: "pointer" }}
              >
                Title {renderSortIcon("title")}
              </th>
              <th
                onClick={() => handleSort("description")}
                style={{ cursor: "pointer" }}
              >
                description {renderSortIcon("description")}
              </th>
              <th
                onClick={() => handleSort("designation.designationName")}
                style={{ cursor: "pointer" }}
              >
                Job Role {renderSortIcon("designation.designationName")}
              </th>
              <th
                onClick={() => handleSort("departmentName")}
                style={{ cursor: "pointer" }}
              >
                Department {renderSortIcon("departmentName")}
              </th>
              <th
                onClick={() => handleSort("year")}
                style={{ cursor: "pointer" }}
              >
                Year {renderSortIcon("year")}
              </th>
              <th
                onClick={() => handleSort("weight")}
                style={{ cursor: "pointer" }}
              >
                Weight (%) {renderSortIcon("weight")}
              </th>
              <th
                onClick={() => handleSort("createdDate")}
                style={{ cursor: "pointer" }}
              >
                Created Date {renderSortIcon("createdDate")}
              </th>
              <th
                onClick={() => handleSort("approvalStatus")}
                style={{ cursor: "pointer" }}
              >
                Status {renderSortIcon("approvalStatus")}
              </th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={10} className="text-center">
                  Loading...
                </td>
              </tr>
            ) : sortedData?.length > 0 ? (
              sortedData?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>

                  <td>{item?.title}</td>
                  <td>{item?.description}</td>
                  <td>{item?.designation?.designationName}</td>
                  <td>{item?.departmentName}</td>
                  <td>{item?.year}</td>
                  <td>{item?.weight}%</td>
                  <td>{FormatDateTime(item?.createdDate, "DD/MM/YYYY")}</td>
                  <td>{item?.approvalStatus}</td>

                  <td>
                    <TableActions
                      hasChildren={true}
                      url={
                        matchedPermissionHr || matchedPermissionJAO
                          ? `${item.id}/view`
                          : null
                      }
                    >
                      {[
                        {
                          name:
                            matchedPermissionHr || matchedPermissionJAO
                              ? "View"
                              : null,
                          action: () =>
                            matchedPermissionHr || matchedPermissionJAO
                              ? handleView(item.id)
                              : null,
                        },
                      ]}
                    </TableActions>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={10} className="text-center">
                  No Objectives Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
      <Pagination
        last_page={data?.totalPages}
        present_page={data?.currentPage}
        totalRows={data?.totalRows}
        setPageSize={(page) => setPageSize(page)}
        click={(page) => setCurrentPage(page)}
      />
      {openModal && (
        <AppModalTemplate
          width={"600px"}
          isOpen={openModal}
          zIndex={1000}
          setIsOpen={handleModal}
        >
          <ObjectiveModal3
            onValidate={onValidate}
            isOpen={openModal}
            setIsOpen={setOpenModal}
          />
        </AppModalTemplate>
      )}
      {openAutogeneratedModal && (
        <AppModalTemplate
          width={"600px"}
          zIndex={1000}
          isOpen={openAutogeneratedModal}
          setIsOpen={handleAutogeneratedModal}
        >
          <AutogeneratedKRAModal
            onValidate={onValidate}
            isOpen={openAutogeneratedModal}
            setIsOpen={setOpenAutogeneratedModal}
          />
        </AppModalTemplate>
      )}

      <style jsx>{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }

        @media (max-width: 1024px) {
          .desktop-table-view {
            display: none !important;
          }
          .mobile-card-view {
            display: block !important;
          }
        }

        @media (min-width: 1025px) {
          .desktop-table-view {
            display: block !important;
          }
          .mobile-card-view {
            display: none !important;
          }
        }

        @media (max-width: 768px) {
          .${DashboardStyle.dashboard_filter} {
            flex-direction: column;
            gap: 1rem;
          }

          .${DashboardStyle.dashboard_filter} > * {
            width: 100%;
          }
        }
      `}</style>
    </PageStyle>
  );
};

export default KeyResultArea;
